import logger from 'js/app/loggerSingleton';

import { useTracker } from '@coursera/event-pulse/react';

const BUTTON_NAMES = {
  MONTHLY_CTA: 'start_cplus_monthly',
  ANNUALLY_CTA: 'start_cplus_annually',
} as const;

const SECTION_NAMES = {
  HERO: 'coursera_plus_hero',
  STICKY_HEADER: 'sticky_page_header',
  PRICE_COMPARISON: 'comparision_table',
  FOOTER: 'bottom_banner',
  LEARNER_STATS: 'learner_statistics',
  COLLECTION: 'coursera_plus_collection',
} as const;

/* eslint-disable camelcase */
const TRACKING_NAME_MAP: Record<
  string,
  {
    buttonName: (typeof BUTTON_NAMES)[keyof typeof BUTTON_NAMES];
    sectionName: (typeof SECTION_NAMES)[keyof typeof SECTION_NAMES];
  }
> = {
  hero_monthly: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.HERO,
  },
  hero_annual: {
    buttonName: BUTTON_NAMES.ANNUALLY_CTA,
    sectionName: SECTION_NAMES.HERO,
  },
  sticky_banner_monthly: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.STICKY_HEADER,
  },
  monthly_from_price_comparison: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.PRICE_COMPARISON,
  },
  yearly_from_price_comparison: {
    buttonName: BUTTON_NAMES.ANNUALLY_CTA,
    sectionName: SECTION_NAMES.PRICE_COMPARISON,
  },
  footer_monthly: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.FOOTER,
  },
  footer_annual: {
    buttonName: BUTTON_NAMES.ANNUALLY_CTA,
    sectionName: SECTION_NAMES.FOOTER,
  },
  learner_statistics_monthly: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.LEARNER_STATS,
  },
  learner_statistics_annual: {
    buttonName: BUTTON_NAMES.ANNUALLY_CTA,
    sectionName: SECTION_NAMES.LEARNER_STATS,
  },
  collections_monthly: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.COLLECTION,
  },
  collections_annual: {
    buttonName: BUTTON_NAMES.MONTHLY_CTA,
    sectionName: SECTION_NAMES.COLLECTION,
  },
} as const;
/* eslint-enable camelcase */

export const useCourseraPlusEventing = () => {
  const track = useTracker();

  const trackCta = (trackingName: string) => {
    const { buttonName, sectionName } = TRACKING_NAME_MAP[trackingName] || {};

    if (!buttonName || !sectionName) {
      logger.error(`Unable to track CTA with trackingName ${trackingName}`);
      return;
    }

    track('click_button', {
      button: {
        name: buttonName,
      },
      pageSection: {
        sectionName,
      },
    });
  };

  return {
    trackCta,
  };
};
